import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhyUsSection from './components/WhyUsSection';
import ServicesSection from './components/ServicesSection';
import ReferencieSection from './components/ReferencieSection';
import StatsSection from './components/StatsSection';
import ProcessSection from './components/ProcessSection';
import PortalTeaser from './components/PortalTeaser';
import PricingSection from './components/PricingSection';
import BlogSection from './components/BlogSection';
import FaqSection from './components/FaqSection';
import KontaktSection from './components/KontaktSection';
import FooterSection from './components/FooterSection';
import FloatingWhatsApp from './components/FloatingWhatsApp';

export default function Home() {
  return (
    <main className="min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <WhyUsSection />
      <ServicesSection />
      <ReferencieSection />
      <StatsSection />
      <ProcessSection />
      <PortalTeaser />
      <PricingSection />
      <BlogSection />
      <FaqSection />
      <KontaktSection />
      <FooterSection />
      <FloatingWhatsApp />
    </main>
  );
}
